module.exports = __webpack_public_path__ + "img/selected6-min.09413e2d.png";